import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DocumentService } from 'src/app/Services/Documents/document.service';
import { DatePipe } from '@angular/common';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { IDocument } from 'src/app/models/IDocument';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { AuditLog } from 'src/app/models/iauditlog.model';
import { SharedService } from 'src/app/Sharedservice/SharedService';

@Component({
  selector: 'app-edit-document',
  templateUrl: './edit-document.component.html',
  styleUrls: ['./edit-document.component.css']
})
export class EditDocumentComponent implements OnInit {
  disabled;
  docmentInfo: IDocument;
  ImportDocForm: FormGroup;
  public docCatList: IDocument[] = [];
  public childDocCategories: IDocument[] = [];
  public listProviders: IUserDetails[];
  public docCatId: number = 1;
  public catName: string = 'DEMOGRAPHICS';

  public filename: string;

  public myFiles: string[] = [];

  providerControl = new FormControl('', [Validators.required]);

  constructor(private fb: FormBuilder, private docService: DocumentService,
    private datePipe: DatePipe, public dialog: MatDialog,
    private sharedService: SharedService,
    public dialogRef: MatDialogRef<EditDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDocument) { }

  formErrors = {
    'documentCategory': '',
    'docDescription': '',
    'documentName': '',
    'documentdate': '',
  };

  validationMessages = {
    'documentCategory': {
      'required': 'Please Select the Document Category',
    },
    'docDescription': {
      'required': 'Please Enter Document Description'
    },
    'documentName': {
      'required': 'Please Upload the Document'
    },
    'documentdate': {
      'required': 'Please Select the Current Date'
    },
  };

  ngOnInit() {
    this.ImportDocForm = this.fb.group({
      patientId: [''],
      patientName: [''],
      documentCategory: ['', Validators.required],
      docDescription: ['', Validators.required],
      providerName: [''],
      documentdate: ['', Validators.required],
      docComments: [''],
      facilityId: [''],
      documentId: [''],
      childDocCategories: [''],
      multipleScans: [''],
      docCategoryId: [''],
      dateofService: [''],
      createdBy: [''],
    });

    this.GetIDocInfo();
    this.getAllProvider();
    this.getAllDocCategoryList();
  }

  GetPatientDetails() {
    this.ImportDocForm.patchValue({
      patientId: this.data.patientId,
      patientName: 'VigiBoss',
      documentCategory: this.data.documentCategory,
      facilityId: this.data.facilityId,
      docCategoryId: this.data.docCategoryId,
      documentId: this.data.documentId,
      dateofService: this.data.documentdate,
      createdBy: '+4anCIDq034Ii3VbSAAYHcQ==',
    });
  }

  GetIDocInfo() {
    this.docmentInfo = {
      documentId: null,
      documentName: '',
      documentdate: '',
      subCategoryId: null,
      subCategoryName: '',
      //categoryId: null,
      docCategoryId: null,
      documentCategory: '',
      patientId: null,
      patFullName: '',
      patDOB: null,
      patGender: '',
      patAge: null,
      extension: '',
      encounterId: '',
      facilityId: null,
      createdBy: '',
      locationId: null,
      fluoroscopeId: null,
      count: null,
      reportDocumentId: null
    }
  }

  mapFormValuesToDocumetModel() {
    this.docmentInfo.documentCategory = this.ImportDocForm.value.documentCategory;
    this.docmentInfo.facilityId = this.ImportDocForm.value.facilityId;
    this.docmentInfo.documentId = this.ImportDocForm.value.documentId;
    this.docmentInfo.docCategoryId = this.ImportDocForm.value.docCategoryId;
    this.docmentInfo.documentdate = this.ImportDocForm.value.documentdate;

    this.docmentInfo.patientId = this.ImportDocForm.value.patientId;
    this.docmentInfo.patFullName = this.ImportDocForm.value.patientName;
    this.docmentInfo.documentName = this.ImportDocForm.value.documentName;
    this.docmentInfo.documentdate = this.ImportDocForm.value.documentdate;

  }

  getAllProvider() {
    this.docService.getAllProviders('Doctor').subscribe(data => {
      this.listProviders = data;
      this.GetPatientDetails();
    });
  }

  getAllDocCategoryList() {
    if (sessionStorage.getItem('patientId') !== '' && sessionStorage.getItem('patientId') !== undefined) {
      this.docService.getAllDocCategory(Number(sessionStorage.getItem('patientId')), Number(sessionStorage.getItem("FacilityId"))).subscribe(data => {
        this.docCatList = data;
        this.AuditLogs("USP_EMR_GET_ALLDOCCATEGORIES", Number(sessionStorage.getItem('patientId')));
      });
    }
  }

  public _auditLog: AuditLog;
  AuditLogs(sp: any, input: any) {
    this._auditLog = new AuditLog();
    this._auditLog.InputParameters = input;
    this._auditLog.SPName = sp;
    this.sharedService.selectCopyPrintAuditLog(this._auditLog).subscribe(async result => {
      await result;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

